import { BlueCrossBlueShieldModalView } from './BlueCrossBlueShieldModalView';
import { connect } from 'react-redux';
import {
    bcbsCarriersSelector,
    fetchBcbsCarriersIfNeeded,
} from '../../bcbsCarriers';

export function mapStateToProps(state) {
    const carriers = bcbsCarriersSelector(state);

    if (!carriers || carriers.length === 0) {
        return {
            isLoading: true,
            carriers: [],
        };
    }

    return {
        isLoading: false,
        carriers,
    };
}

export const mapDispatchToProps = {
    fetchBcbsCarriersIfNeeded,
};

export const BlueCrossBlueShieldModalConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(BlueCrossBlueShieldModalView);
